var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center my20"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-sizes":[5, 10, 30, 50],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total,"small":""},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }